import React, { useState } from "react"
import { useNavigate } from "react-router-dom"
import API from "../services/api"
import { setUser, setToken } from '../utils/storage'
import { auth, googleProvider } from "../firebaseConfig"
import { signInWithPopup } from "firebase/auth"

const Login = () => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [accepted, setAccepted] = useState(false)

  // ✅ GOOGLE LOGIN HANDLER
  const handleGoogleLogin = async () => {
    if (!accepted) return alert("Please accept Terms & Conditions to proceed")
    setLoading(true)
    try {
      const result = await signInWithPopup(auth, googleProvider)
      const user = result.user
      const deviceId = getDeviceId()

      const res = await API.post("/auth/social-login", {
        email: user.email,
        firstName: user.displayName?.split(" ")[0] || "User",
        lastName: user.displayName?.split(" ")[1] || "",
        photoURL: user.photoURL,
        deviceId
      })

      setToken(res.data.token)
      setUser(res.data.user)
      navigate("/home", { replace: true })
    } catch (err) {
      console.error("Firebase Auth Error:", err)
      // Provide more specific error info
      const errMsg = err.code ? `Google Login Failed: ${err.code} (${err.message})` : "Google Login Failed. Please check your Firebase Config.";
      alert(errMsg)
    } finally {
      setLoading(false)
    }
  }

  // ✅ 1. DEVICE ID GENERATION
  const getDeviceId = () => {
    let id = localStorage.getItem("winrox11_device_id")
    if (!id) {
        id = 'device_' + Math.random().toString(36).substr(2, 9) + Date.now();
        localStorage.setItem("winrox11_device_id", id)
    }
    return id
  }



  return (
    <div className="bg-theme-bg min-h-screen flex flex-col items-center justify-center p-6 relative overflow-hidden">
      
      {/* Floating Decorative Orbs */}
      <div className="absolute top-[-10%] right-[-10%] w-[80%] h-[40%] bg-accent/10 rounded-full blur-[120px] animate-float"></div>
      <div className="absolute bottom-[-10%] left-[-10%] w-[60%] h-[30%] bg-accent/10 rounded-full blur-[100px] animate-float-delayed"></div>
      <div className="absolute top-[20%] left-[5%] w-32 h-32 bg-blue-500/5 rounded-full blur-3xl animate-float-subtle"></div>

      {loading && (
        <div className="absolute inset-0 z-[100] bg-theme-bg/80 flex flex-col items-center justify-center backdrop-blur-sm">
           <div className="w-10 h-10 border-2 border-accent border-t-transparent rounded-full animate-spin"></div>
           <p className="mt-6 text-theme-text font-bold tracking-widest text-[10px] uppercase opacity-60">Authenticating...</p>
        </div>
      )}

      {/* Main Login Card */}
      <div className="glass-card rounded-[40px] p-10 w-full max-w-[360px] shadow-theme-lg animate-scale-up border border-theme-border flex flex-col items-center relative z-10 transition-all hover-glow">
        
        {/* Fantasy Logo Holder */}
        <div className="relative mb-8 pt-4">
           <div className="absolute inset-0 bg-accent/10 blur-[40px] rounded-full scale-125"></div>
           <img src="/cricket_logo.png" alt="WinroX11 Logo" className="w-24 h-24 rounded-[28%] relative z-10 shadow-theme-sm border-2 border-theme-border p-1 bg-theme-bg" />
        </div>

        <h1 className="text-4xl font-black tracking-tighter text-theme-text mb-2 uppercase italic">Winro<span className="text-accent underline decoration-4 underline-offset-4 decoration-accent/50">X11</span></h1>
        <p className="text-theme-text-sec text-[10px] mb-10 text-center font-extrabold opacity-40 uppercase tracking-[0.3em]">Ultimate Fantasy Universe</p>

        <div className="flex items-start space-x-3 py-2 mb-6">
          <input 
             type="checkbox" 
             id="tc"
             className="mt-1 w-4 h-4 rounded border-theme-border bg-theme-bg text-accent focus:ring-accent accent-accent cursor-pointer"
             checked={accepted}
             onChange={(e) => setAccepted(e.target.checked)}
          />
          <label htmlFor="tc" className="text-[10px] text-theme-text-sec leading-relaxed cursor-pointer font-bold uppercase tracking-tight opacity-60">
            I agree to the <span onClick={() => navigate("/terms")} className="text-accent underline">T&C</span>, <span onClick={() => navigate("/fairplay")} className="text-accent underline">Fair Play</span> and <span onClick={() => navigate("/privacy")} className="text-accent underline">Privacy</span>. I am 18+ years old.
          </label>
        </div>

        {/* Google Login Button */}
        <button 
          onClick={handleGoogleLogin}
          className="w-full py-5 rounded-2xl font-black text-[11px] tracking-widest uppercase bg-theme-bg/60 text-theme-text hover:bg-theme-bg transition-all flex items-center justify-center space-x-3 shadow-theme-md active:scale-95 border border-theme-border hover-glow backdrop-blur-sm"
        >
          <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="Google" className="w-5 h-5 shadow-sm" />
          <span>Continue with Google</span>
        </button>

        <div className="mt-8 text-center text-[8px] text-gray-600 font-bold tracking-widest opacity-60 uppercase leading-relaxed">
          <p>© 2026 WINROX11 FANTASY SPORTS</p>
          <p className="mt-1 text-theme-text-sec">PLAY RESPONSIBLY • 18+ ONLY</p>
        </div>

      </div>
    </div>
  )
}

export default Login